// Pending AI care-plan suggestions (generate-and-persist on save → review).
export const GENERATE_AI_SUGGESTIONS = "app/AiSuggestions/GENERATE";
export const FETCH_AI_SUGGESTIONS = "app/AiSuggestions/FETCH";
export const FETCH_AI_SUGGESTIONS_SUCCESS = "app/AiSuggestions/FETCH_SUCCESS";
export const FETCH_AI_SUGGESTIONS_FAILURE = "app/AiSuggestions/FETCH_FAILURE";
export const ACCEPT_AI_SUGGESTION = "app/AiSuggestions/ACCEPT";
export const DISMISS_AI_SUGGESTION = "app/AiSuggestions/DISMISS";
